import { render } from "./AiHeader.vue?vue&type=template&id=2e18bda4&scoped=true"
import script from "./AiHeader.vue?vue&type=script&lang=js"
export * from "./AiHeader.vue?vue&type=script&lang=js"

import "./AiHeader.vue?vue&type=style&index=0&id=2e18bda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e18bda4"]])

export default __exports__